<template>
  <div class="cost-query-container">
    <HomeHeader  />
    <div class="w1200" id="main_content">
      <div class="cost-query-content">

        <el-form :model="queryForm" :rules="rules" ref="queryFormRef" label-width="80px" class="cost-query-form">
<!--          <el-row :gutter="20" class="natural-language-row">-->
<!--            <el-col :span="24">-->
<!--              <el-form-item label-width="0px">-->
<!--                <div class="natural-language-input">-->
<!--                  <el-input-->
<!--                    v-model="naturalLanguageQuery"-->
<!--                    type="textarea"-->
<!--                    :rows="4"-->
<!--                    placeholder="输入发货与收货信息后点击“智能解析”，系统自动拆分并回填到下方表单，确认无误后再查询。"-->
<!--                    resize="none"-->
<!--                  ></el-input>-->
<!--                  <el-button-->
<!--                    class="parse-btn"-->
<!--                    type="success"-->
<!--                    :loading="parsing"-->
<!--                    :disabled="!naturalLanguageQuery.trim()"-->
<!--                    @click="parseNaturalLanguage"-->
<!--                  >-->
<!--                    智能解析-->
<!--                  </el-button>-->
<!--                </div>-->
<!--              </el-form-item>-->
<!--            </el-col>-->
<!--          </el-row>-->

          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="目的地:" prop="destination">
                <el-input
                  v-model="queryForm.destination"
                  type="textarea"
                  :rows="4"
                  placeholder="目的地"
                  resize="none"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="尺寸规格:" prop="sizeSpecification">
                <el-input
                  v-model="queryForm.sizeSpecification"
                  type="textarea"
                  :rows="4"
                  placeholder="长(cm)宽(cm)高(cm)件数，使用*分隔尺寸与件数,使用回车分隔不同规格，例：100*150*200*3
--尺寸与体积至少填写一个"
                  resize="none"
                  @input="validateSizeSpecification"
                  @blur="calculateVolumeAndPieces"
                ></el-input>
                <div id="size_spec_error" class="text-danger small mt-1" v-show="showSizeSpecError">{{ sizeSpecErrorMsg }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="实际重量(kg):" prop="actualWeight">
                <el-input
                  v-model="queryForm.actualWeight"
                  type="textarea"
                  :rows="4"
                  placeholder="货物实际总重量，单位千克"
                  resize="none"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20" class="mt-3">
            <el-col :span="8">
              <el-form-item label="体积规格:" prop="volumeSpecification">
                <el-input
                  v-model="queryForm.volumeSpecification"
                  placeholder="总体积(立方米)例如：0.5、3"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="件数:" prop="pieces">
                <el-input
                  v-model="queryForm.pieces"
                  placeholder="选填，件数"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="支付类型:" prop="paymentType">
                <el-select v-model="queryForm.paymentType" placeholder="请选择支付类型">
                  <el-option label="现金" value="现金"></el-option>
                  <el-option label="到付" value="到付"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20" class="mt-3">
            <el-col :span="12">
              <el-form-item label="货物名称:" prop="itemName">
                <el-input
                  v-model="queryForm.itemName"
                  placeholder="选填"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="保价额度:" prop="declaredValue">
                <div class="declared-value-wrap">
                  <el-input
                    v-model="queryForm.declaredValue"
                    placeholder="选填，不填则按各公司默认保价"
                  ></el-input>
                  <div class="quick-declare">
                    <span class="quick-declare-tag" @click="queryForm.declaredValue = '1000'">1000</span>
                    <span class="quick-declare-tag" @click="queryForm.declaredValue = '2000'">2000</span>
                  </div>
                </div>
              </el-form-item>
            </el-col>
          </el-row>

          <div style="text-align: right; margin-top: 20px;">
            <el-button type="primary" @click="submitForm" :loading="loading">查询</el-button>
          </div>
        </el-form>

        <!-- 查询结果展示 -->
        <div v-if="queryResult" class="mt-4 result-scroll-container">
          <el-card>
            <el-table :data="queryResult" style="width: 100%" stripe>
              <!-- 网点名称 -->
              <el-table-column label="网点名称" width="150">
                <template #default="scope">
                  <div>{{ scope.row.company_name }}</div>
                  <div style="font-size: 12px; color: #909399;">{{ scope.row.site || '-' }}</div>
                </template>
              </el-table-column>

              <!-- 价格（成本价经子用户绑定加价策略计算后） -->
              <el-table-column label="价格" width="180">
                <template #default="scope">
                  <div v-if="scope.row.success && scope.row.suggested_prices">
                    <div v-if="scope.row.suggested_prices.total_price">
                      ¥{{ scope.row.suggested_prices.total_price }}
                    </div>
                    <div v-if="scope.row.suggested_prices.total_price_yunda_heavy" class="yunda-heavy-price">
                      ¥{{ scope.row.suggested_prices.total_price_yunda_heavy }} (韵重货)
                    </div>
                    <div v-if="scope.row.suggested_prices.total_price_ane_fixed" class="yunda-heavy-price">
                      ¥{{ scope.row.suggested_prices.total_price_ane_fixed }} (安能一口价)
                    </div>
                  </div>
                  <span v-else>-</span>
                </template>
              </el-table-column>

              <!-- 计费重量 -->
              <el-table-column label="计费重量" width="120">
                <template #default="scope">
                  {{ getCalculatedWeight(scope.row) }}
                </template>
              </el-table-column>

              <!-- 加收信息 -->
              <el-table-column label="加收信息" >
                <template #default="scope">
                  <el-popover
                    v-if="scope.row.success && renderAdditionInfo(scope.row)"
                    placement="top"
                    width="300"
                    trigger="hover"
                    :hide-after="0"
                    :popper-options="{ modifiers: [{ name: 'preventOverflow', options: { padding: 10 } }] }"
                  >
                  <div v-html="renderAdditionInfo(scope.row)"></div>
                    <template #reference>
                        <el-icon size="18" color="#f56c6c">
                                  <Warning />
                        </el-icon>
                      </template>
                  </el-popover>
                  <span v-else>-</span>
                </template>
              </el-table-column>

              <!-- 特殊信息 -->
              <el-table-column label="特殊信息" >
                <template #default="scope">
                  <div v-if="scope.row.success">
                    <el-popover
                      v-if="renderWarnInfo(scope.row)"
                      placement="top"
                      width="300"
                      trigger="hover"
                      :hide-after="0"
                      :popper-options="{ modifiers: [{ name: 'preventOverflow', options: { padding: 10 } }] }"
                    >
                    <div v-html="renderWarnInfo(scope.row)"></div>
                      <template #reference>
                        <el-icon size="18" color="#f56c6c" style="margin-right: 5px;">
                               <Warning />
                        </el-icon>
                      </template>
                    </el-popover>

                    <el-popover
                      v-if="scope.row.price_data.des_site_info && scope.row.price_data.des_site_info.TownMsg && typeof scope.row.price_data.des_site_info.TownMsg === 'string' && scope.row.price_data.des_site_info.TownMsg.trim()"
                      placement="top"
                      width="300"
                      trigger="hover"
                      :hide-after="0"
                      :popper-options="{ modifiers: [{ name: 'preventOverflow', options: { padding: 10 } }] }"
                    >
                      <div v-html="scope.row.price_data.des_site_info.TownMsg"></div>
                      <template #reference>
                        <el-icon size="18" color="#f56c6c">
                       <Warning />
                        </el-icon>
                      </template>
                    </el-popover>
                  </div>
                  <span v-else>-</span>
                </template>
              </el-table-column>

              <!-- 路径时效 -->
              <el-table-column label="路径时效" >
                <template #default="scope">
                  <el-popover
                    v-if="scope.row.success && renderRouteInfo(scope.row)"
                    placement="top"
                    width="400"
                    trigger="hover"
                    :hide-after="0"
                    :popper-options="{ modifiers: [{ name: 'preventOverflow', options: { padding: 10 } }] }"
                  >
                    <div v-html="renderRouteInfo(scope.row)"></div>
                    <template #reference>
                        <el-icon size="18" color="#67c23a">
                       <Warning />
                        </el-icon>
                      </template>
                  </el-popover>
                  <span v-else>-</span>
                </template>
              </el-table-column>

              <!-- 其他信息 -->
              <el-table-column label="其他信息">
                <template #default="scope">
                  <el-popover
                    v-if="scope.row.success && renderOtherInfo(scope.row)"
                    placement="top"
                    width="300"
                    trigger="hover"
                    :hide-after="0"
                    :popper-options="{ modifiers: [{ name: 'preventOverflow', options: { padding: 10 } }] }"
                  >
                  <div v-html="renderOtherInfo(scope.row)"></div>
                    <template #reference>
                        <el-icon size="18" color="#409eff">
                          <Warning />
                        </el-icon>
                      </template>
                  </el-popover>
                  <span v-else>-</span>
                </template>
              </el-table-column>

              <!-- 查询状态 -->
              <el-table-column label="查询状态" width="100">
                <template #default="scope">
                  <el-tag :type="scope.row.success ? 'success' : 'danger'">
                    {{ scope.row.success ? '成功' : '失败' }}
                  </el-tag>
                </template>
              </el-table-column>
            </el-table>
          </el-card>
        </div>

      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, watch, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import { postWlApi } from '@utils/api_v1.js'
import HomeHeader from '@components/HomeHeader.vue'
import { useWuliu178AuthStore } from '@store/auth.js'
import {  Warning } from '@element-plus/icons-vue'

// 表单数据
const queryForm = reactive({
  destination: '',
  sizeSpecification: '',
  actualWeight: '',
  volumeSpecification: '',
  pieces: '',
  paymentType: '现金',
  itemName: '',
  declaredValue: ''
})

// 表单引用
const queryFormRef = ref(null)

// 尺寸规格验证错误
const showSizeSpecError = ref(false)
const sizeSpecErrorMsg = ref('')

// 查询结果
const queryResult = ref(null)
const queryId = ref('')
const loading = ref(false)

// 子用户绑定的加价策略
const wlAuth = useWuliu178AuthStore()
const currentStrategy = ref(null)

const TOTAL_FIELDS = ['total_price', 'total_price_yunda_heavy', 'total_price_ane_fixed']

// 判断计费量是否命中规则区间（条件：起始值 op1 类型 op2 结束值）
const quantityMatchesRule = (qty, rule) => {
  const sv = Number(rule.start_value)
  const ev = Number(rule.end_value)
  let ok = true
  if (rule.start_operator === '<') ok = sv < qty
  else if (rule.start_operator === '<=') ok = sv <= qty
  else if (rule.start_operator === '>') ok = sv > qty
  else ok = sv >= qty
  if (!ok) return false
  if (rule.end_operator === '<') ok = qty < ev
  else if (rule.end_operator === '<=') ok = qty <= ev
  else if (rule.end_operator === '>') ok = qty > ev
  else ok = qty >= ev
  return ok
}

// 计费量区间[0, qty]与规则区间的重叠长度（开闭边界不影响长度，用于分段计价）
const segmentOverlap = (qty, rule) => {
  const sv = (rule.start_value === '' || rule.start_value == null) ? 0 : Number(rule.start_value)
  const ev = (rule.end_value === '' || rule.end_value == null) ? Infinity : Number(rule.end_value)
  const lo = Math.max(0, sv)
  const hi = Math.min(qty, ev)
  return hi > lo ? hi - lo : 0
}

// 按方案计价方式计算单个成本的建议收费（分段混合计价）
// 计费量覆盖到的每个区间都按各自的计价方式加收：
//  按单位加收 = 区间覆盖长度 × 单价
//  固定加收 = 区间被覆盖则加收固定金额一次
//  按百分比加收 = 成本 × (区间覆盖长度/计费量) × 百分比（成本按计费量占比分摊）
// 例：0<重量<=10 固定加收5元、10<重量<=999999 按3%加收，重量15成本100
//     加收 = 5 + 100×(5/15)×3% = 6
// 额外加收（元/票）按计费量命中的区间收取一次
const calcSuggestedPrice = (strategy, qty, cost) => {
  const rules = strategy.rules || []
  const matched = rules.find(r => quantityMatchesRule(qty, r))
  if (!matched) return cost.toFixed(2)
  let markup = 0
  rules.forEach(r => {
    const overlap = segmentOverlap(qty, r)
    if (overlap <= 0) return
    const pv = Number(r.price_value) || 0
    if (r.price_mode === 'per_unit') markup += overlap * pv
    else if (r.price_mode === 'fixed') markup += pv
    else markup += cost * (overlap / qty) * pv / 100
  })
  const extraFee = Number(matched.extra_fee) || 0
  return (cost + markup + extraFee).toFixed(2)
}

// 获取行用于加价试算的计费量（重量方案使用计费重量，而非实际重量）
const getStrategyQuantity = (row, chargeType) => {
  if (chargeType === 'weight') {
    const w = parseFloat(getCalculatedWeight(row))
    if (!isNaN(w)) return w
    const aw = parseFloat(queryForm.actualWeight)
    return isNaN(aw) ? null : aw
  }
  if (chargeType === 'volume') {
    const v = parseFloat(queryForm.volumeSpecification)
    return isNaN(v) ? null : v
  }
  const p = parseFloat(queryForm.pieces)
  return isNaN(p) ? null : p
}

// 对全部查询结果行重新试算建议收费
const recalcSuggestedPrices = () => {
  if (!queryResult.value) return
  const strategy = currentStrategy.value
  queryResult.value.forEach(row => {
    row.suggested_prices = null
    if (!strategy || !row.success || !row.price_data) return
    const qty = getStrategyQuantity(row, strategy.charge_type)
    if (qty === null) return
    const prices = {}
    let hasAny = false
    TOTAL_FIELDS.forEach(field => {
      const cost = parseFloat(row.price_data[field])
      if (isNaN(cost) || cost <= 0) return
      prices[field] = calcSuggestedPrice(strategy, qty, cost)
      hasAny = true
    })
    if (hasAny) row.suggested_prices = prices
  })
}

// 自动加载子用户绑定的加价策略并试算价格
const loadSubUserStrategy = async () => {
  const strategyId = wlAuth.userProfile?.cost_strategy_id
  if (!strategyId) return
  try {
    const res = await postWlApi('/cost_strategy/detail', { id: strategyId })
    if (res && res.code === 0) {
      currentStrategy.value = res.data.strategy
      recalcSuggestedPrices()
    }
  } catch (e) {
    console.error(e)
  }
}

// 新查询结果产生后，自动按绑定策略计算价格
watch(queryResult, () => {
  currentStrategy.value = null
  loadSubUserStrategy()
})

onMounted(async () => {
  // 确保已加载用户信息（含绑定的加价策略id）
  if (!wlAuth.userProfile) {
    try {
      const res = await postWlApi('/user/profile', {})
      if (res && res.data) wlAuth.setUserProfile(res.data)
    } catch (e) {
      console.error(e)
    }
  }
  loadSubUserStrategy()
})

// 自然语言查询
const naturalLanguageQuery = ref('')
const parsing = ref(false)

// 表单验证规则
const rules = {
  destination: [
    { required: true, message: '请输入目的地', trigger: 'blur' }
  ],
  actualWeight: [
    { required: true, message: '请输入实际重量', trigger: 'blur' }
  ],
  sizeSpecification: [
    {
      validator: (rule, value, callback) => {
        // 尺寸规格和体积规格至少填写一个
        if (!value.trim() && !queryForm.volumeSpecification.trim()) {
          callback(new Error('尺寸规格与体积至少填写一个'))
        } else {
          callback()
        }
      },
      trigger: ['blur', 'change']
    }
  ],
  volumeSpecification: [
    {
      validator: (rule, value, callback) => {
        // 尺寸规格和体积规格至少填写一个
        if (!value.trim() && !queryForm.sizeSpecification.trim()) {
          callback(new Error('尺寸规格与体积至少填写一个'))
        } else {
          callback()
        }
      },
      trigger: ['blur', 'change']
    }
  ]
}

// 验证尺寸规格
const validateSizeSpecification = () => {
  if (!queryForm.sizeSpecification.trim()) {
    showSizeSpecError.value = false
    return true
  }

  const lines = queryForm.sizeSpecification.trim().split('\n')
  for (const line of lines) {
    const trimmedLine = line.trim()
    if (!trimmedLine) continue

    const parts = trimmedLine.split('*')
    if (parts.length !== 4) {
      showSizeSpecError.value = true
      sizeSpecErrorMsg.value = '尺寸规格格式错误，每行必须包含4个参数：长*宽*高*件数'
      return false
    }

    // 验证每个参数是否为数字
    for (let i = 0; i < 4; i++) {
      const num = parseFloat(parts[i])
      if (isNaN(num) || num <= 0) {
        showSizeSpecError.value = true
        sizeSpecErrorMsg.value = '尺寸规格中的参数必须为正数'
        return false
      }
    }
  }

  showSizeSpecError.value = false
  return true
}

// 计算体积和件数
const calculateVolumeAndPieces = () => {
  if (!queryForm.sizeSpecification.trim()) {
    return
  }

  // 验证尺寸规格格式
  if (!validateSizeSpecification()) {
    return
  }

  const lines = queryForm.sizeSpecification.trim().split('\n')
  let totalVolume = 0 // 总体积，单位：立方米
  let totalPieces = 0 // 总件数

  for (const line of lines) {
    const trimmedLine = line.trim()
    if (!trimmedLine) continue

    const parts = trimmedLine.split('*')
    const length = parseFloat(parts[0]) // 长，单位：厘米
    const width = parseFloat(parts[1]) // 宽，单位：厘米
    const height = parseFloat(parts[2]) // 高，单位：厘米
    const pieces = parseFloat(parts[3]) // 件数

    // 计算单条记录的体积（立方米）：长(cm)*宽(cm)*高(cm)*件数 / 1000000
    const volume = (length * width * height * pieces) / 1000000
    totalVolume += volume
    totalPieces += pieces
  }

  // 更新体积规格和件数字段
  queryForm.volumeSpecification = totalVolume.toFixed(6)
  queryForm.pieces = totalPieces.toString()
}

// 解析自然语言查询
const parseNaturalLanguage = async () => {
  const text = naturalLanguageQuery.value.trim()
  if (!text) {
    ElMessage.warning('请输入自然语言查询内容')
    return
  }

  parsing.value = true
  try {
    const response = await postWlApi('/parse_natural_language', {
      natural_language: text
    })

    if (response.code === 0) {
      const data = response.data || {}

      // 先清空表单，防止上次解析结果污染
      queryForm.destination = ''
      queryForm.sizeSpecification = ''
      queryForm.actualWeight = ''
      queryForm.volumeSpecification = ''
      queryForm.pieces = ''
      queryForm.paymentType = '现金'
      queryForm.itemName = ''
      queryForm.declaredValue = ''

      // 将解析结果回填到表单
      if (data.destination !== undefined) queryForm.destination = data.destination
      if (data.size_spec !== undefined) queryForm.sizeSpecification = data.size_spec
      if (data.actual_weight !== undefined) queryForm.actualWeight = data.actual_weight
      if (data.volume_spec !== undefined) queryForm.volumeSpecification = data.volume_spec
      if (data.pieces !== undefined) queryForm.pieces = data.pieces
      if (data.payment_type !== undefined) queryForm.paymentType = data.payment_type
      if (data.item_name !== undefined) queryForm.itemName = data.item_name
      if (data.declared_value !== undefined) queryForm.declaredValue = data.declared_value

      // 如果解析出了尺寸规格，自动计算体积和件数
      if (data.size_spec) {
        calculateVolumeAndPieces()
      }

      ElMessage.success('解析完成，请检查并修改表单内容')
    } else {
      ElMessage.error(response.message || '解析失败')
    }
  } catch (error) {
    console.error('解析失败:', error)
    ElMessage.error('解析请求失败，请稍后重试')
  } finally {
    parsing.value = false
  }
}

// 表单提交
const submitForm = async () => {
  if (!validateSizeSpecification()) {
    return
  }

  await queryFormRef.value.validate((valid) => {
    if (valid) {
      // 清除之前的查询记录
      queryResult.value = null;
      queryId.value = '';
      // 处理表单数据，转换为后端期望的格式
      const formData = {
        destination: queryForm.destination,
        size_spec: queryForm.sizeSpecification,
        actual_weight: queryForm.actualWeight,
        volume_spec: queryForm.volumeSpecification,
        pieces: queryForm.pieces,
        payment_type: queryForm.paymentType,
        item_name: queryForm.itemName,
        declared_value: queryForm.declaredValue
      }

      // 设置加载状态
      loading.value = true

      // 发送请求到后端
      postWlApi('/cost_query', formData)
        .then(response => {
          loading.value = false
          if (response.code === 0) {
            ElMessage.success('查询成功')
            // 保存查询结果并按company_id排序
            const results = response.data.results
            try {
              queryResult.value = results.sort((a, b) => {
                // 确保company_id存在，不存在的排到后面
                if (!a.company_id) return 1
                if (!b.company_id) return -1
                // 处理company_id可能是数字或字符串的情况
                const idA = Number(a.company_id)
                const idB = Number(b.company_id)
                if (!isNaN(idA) && !isNaN(idB)) {
                  return idA - idB
                }
                // 如果转换为数字失败，则按字符串比较
                return String(a.company_id).localeCompare(String(b.company_id))
              })
            } catch (error) {
              console.error('排序失败:', error)
              // 如果排序失败，直接使用原始结果
              queryResult.value = results
            }
            queryId.value = response.data.query_id
            console.log('查询结果:', response.data)
          } else {
            ElMessage.error(response.message || '查询失败')
          }
        })
        .catch(error => {
          loading.value = false
          console.error('查询失败:', error)
          ElMessage.error('网络错误，请稍后重试')
        })
    } else {
      console.log('表单验证失败')
      return false
    }
  })
}

// 获取计费重量
const getCalculatedWeight = (row) => {
  if (!row.success || !row.price_data) return '-'

  const weightJson = row.price_data.weight_json
  if (weightJson) {
    // 韵达格式
    if (weightJson.Tfr) return parseFloat(weightJson.Tfr).toFixed(2)
    // 安能格式
    if (weightJson.calcWeight) return parseFloat(weightJson.calcWeight).toFixed(2)
    // 顺心捷达格式
    if (weightJson.prodChargeWeight) return parseFloat(weightJson.prodChargeWeight).toFixed(2)

    // 百世快运格式
    if (row.company_id === 6) {
      if (weightJson.siteFeeWeight) return parseFloat(weightJson.siteFeeWeight).toFixed(2)
    }

    if (row.company_id === 7) {
      return row.price_data.calc_weight
        }
  }

  const productInfo = row.price_data.product_info
  if (productInfo && productInfo.calcWeight) {
    // 中通格式
    return parseFloat(productInfo.calcWeight).toFixed(2)
  }

  return '-'
}

// 渲染加收信息
const renderAdditionInfo = (row) => {
  if (!row.success || !row.price_data || !row.price_data.addition_info) return ''

  const additionInfo = row.price_data.addition_info

  if (typeof additionInfo === 'string') {
    return additionInfo
  } else if (Array.isArray(additionInfo)) {
    return additionInfo.map(item => {
      if (typeof item === 'string') return item
      // 安能格式
      if (item.type === 'pickup') {
        return `${item.pickUpName}: ${item.remark}`
      } else if (item.additionName) {
        return `${item.additionName}: ${item.additionRemark}`
      } else if (item.specialAddServiceTypeName) {
        // 顺心捷达格式
        return `${item.specialAddServiceTypeName}: ${item.specialAddressBillingUnitPiece}元/${item.specialAddressBillTypeName}`
      } else {
        return `${item.additionName}: ${item.additionRemark}`
      }
    }).join('<br>')
  } else if (typeof additionInfo === 'object') {
    // 韵达格式
    return Object.entries(additionInfo).map(([add_name, add_info]) => {
      return `${add_name}<br>备注: ${add_info.remark}`
    }).join('<br><br>')
  }

  return ''
}

// 渲染路径时效
const renderRouteInfo = (row) => {
  if (!row.success || !row.price_data || !row.price_data.route_info) return ''

  const routeInfo = row.price_data.route_info

  if (Array.isArray(routeInfo) && routeInfo[0] && routeInfo[0].allUseTm) {
    // 韵达格式
    const track = routeInfo[0]
    let content = `<div class="p-2"><div class="timeline">`
    content += `<div class="total-time">总时效: ${track.allUseTm}</div><br>`

    // 起始节点
    content += `<div class="timeline-item">`
    content += `<div class="timeline-dot start"></div>`
    content += `<div class="timeline-content">`
    content += `<div class="site-name">${track.strtBrch}</div>`
    content += `<div class="status">出发</div>`
    content += `</div></div><br>`

    // 起始分拨中心
    content += `<div class="timeline-item">`
    content += `<div class="timeline-dot"></div>`
    content += `<div class="timeline-content">`
    content += `<div class="site-name">${track.strtDbct}</div>`
    content += `<div class="site-type">始发分拨中心</div>`
    content += `<div class="time">预计到达: ${track.strtBrchHdvr || '未知时间'}</div>`
    content += `<div class="time">预计离开: ${track.strtLev || '未知时间'}</div>`
    content += `<div class="duration">处理时间: ${track.strtUseTm || '未知'}</div>`
    content += `</div></div><br>`

    // 添加中间站点信息
    for (let i = 1; i <= 4; i++) {
      const site = track[`site${i}`]
      if (site) {
        content += `<div class="timeline-item">`
        content += `<div class="timeline-dot"></div>`
        content += `<div class="timeline-content">`
        content += `<div class="site-name">${site}</div>`
        content += `<div class="site-type">分拨中心</div>`
        content += `<div class="time">预计到达: ${track[`site${i}Arv`] || '未知时间'}</div>`
        content += `<div class="time">预计离开: ${track[`site${i}Lev`] || '未知时间'}</div>`
        content += `<div class="duration">处理时间: ${track[`site${i}UseTm`] || '未知'}</div>`
        content += `</div></div><br>`
      }
    }

    // 目的分拨中心
    if (track.destDbct) {
      content += `<div class="timeline-item">`
      content += `<div class="timeline-dot"></div>`
      content += `<div class="timeline-content">`
      content += `<div class="site-name">${track.destDbct}</div>`
      content += `<div class="site-type">目的分拨中心</div>`
      content += `<div class="time">预计到达: ${track.destDbctArv || '未知时间'}</div>`
      content += `<div class="time">预计离开: ${track.destDbctLev || '未知时间'}</div>`
      content += `<div class="duration">处理时间: ${track.destDbctUseTm || '未知'}</div>`
      content += `</div></div><br>`
    }

    // 到达目的地
    if (track.destBrch) {
      content += `<div class="timeline-item">`
      content += `<div class="timeline-dot end"></div>`
      content += `<div class="timeline-content">`
      content += `<div class="site-name">${track.destBrch}</div>`
      content += `<div class="status">预计到达</div>`
      content += `<div class="time">确认时间: ${track.destBrchCfm || '未知'}</div>`
      content += `</div></div><br>`
    }

    content += '</div></div>'
    return content
  } else if (Array.isArray(routeInfo) && routeInfo[0] && routeInfo[0].scanTime) {
    // 安能格式
    let content = '<div class="p-2"><div class="timeline">'

    routeInfo.forEach((node, index) => {
      content += `<div class="timeline-item">`

      // 根据节点类型设置不同的时间点样式
      if (index === 0) {
        content += `<div class="timeline-dot start"></div>`
      } else if (index === routeInfo.length - 1) {
        content += `<div class="timeline-dot end"></div>`
      } else {
        content += `<div class="timeline-dot"></div>`
      }

      content += `<div class="timeline-content">`
      content += `<div class="time">${node.scanTime}</div>`
      content += `<div class="status">${node.scanType}</div>`
      content += `<div class="site-name">${node.scanSiteName}</div>`
      if (node.scanSiteCode) {
        content += `<div class="site-type">站点代码: ${node.scanSiteCode}</div>`
      }
      content += `</div></div><br>`
    })

    content += '</div></div>'
    return content
  } else if (routeInfo.routeActualTimeVOList) {
    // 中通格式
    const nodes = routeInfo.routeActualTimeVOList
    let content = `<div class="p-2"><div class="timeline">`

    // 显示总时效和预计签收时间
    content += `<div class="total-time">总时效: ${routeInfo.workTotalTime}</div>`
    if (routeInfo.signTime) {
      content += `<div class="time text-primary">预计签收: ${routeInfo.signTime}</div>`
    }
    content += `<br>`

    nodes.forEach((node, index) => {
      content += `<div class="timeline-item">`

      // 根据节点位置设置不同的时间点样式
      if (index === 0) {
        content += `<div class="timeline-dot start"></div>`
      } else if (index === nodes.length - 1) {
        content += `<div class="timeline-dot end"></div>`
      } else {
        content += `<div class="timeline-dot"></div>`
      }

      content += `<div class="timeline-content">`

      // 显示站点名称
      content += `<div class="site-name">${node.location}</div>`

      // 显示日期
      if (node.date) {
        content += `<div class="time">${node.date}</div>`
      }

      // 显示目的地/操作
      if (node.destination) {
        content += `<div class="status">${node.destination}</div>`
      }

      // 显示处理时间
      if (node.time) {
        content += `<div class="duration">处理时间: ${node.time}</div>`
      }

      // 显示节点类型标记
      const location = node.location || ''
      if (location.includes('分拨中心')) {
        content += `<div class="site-type">分拨中心</div>`
      } else if (location.includes('签收')) {
        content += `<div class="site-type">目的地</div>`
      }

      content += `</div></div><br>`
    })

    content += '</div></div>'
    return content
  } else if (routeInfo.vo && routeInfo.vo.schedules) {
    // 百世快运格式
    const vo = routeInfo.vo
    let content = `<div class="p-2"><div class="timeline">`

    // 显示总时效和预计送达时间
    if (vo.dayAging) {
      content += `<div class="total-time">总时效: ${vo.dayAging}天</div>`
    }
    // if (vo.resultName) {
    //   content += `<div class="route-desc">${vo.resultName}</div>`
    // }
    if (vo.deliveryDate) {
      content += `<div class="time text-primary">预计送达: ${vo.deliveryDate}</div>`
    }
    content += `<br>`

    // 遍历每个中转节点
    vo.schedules.forEach((schedule, index) => {
      content += `<div class="timeline-item">`

      // 根据节点位置设置不同的时间点样式
      if (index === 0) {
        content += `<div class="timeline-dot start"></div>`
      } else if (index === vo.schedules.length - 1) {
        content += `<div class="timeline-dot end"></div>`
      } else {
        content += `<div class="timeline-dot"></div>`
      }

      content += `<div class="timeline-content">`

      // 显示站点名称
      if (schedule.arrNode && schedule.arrNode.name) {
        content += `<div class="site-name">${schedule.arrNode.name}</div>`
      }

      // // 显示节点类型
      // if (schedule.arrNode && schedule.arrNode.type) {
      //   const typeMap = { 'HUB': '分拨中心', 'SITE': '站点' }
      //   content += `<div class="site-type">${typeMap[schedule.arrNode.type] || schedule.arrNode.type}</div>`
      // }

      // 显示到达时间
      if (schedule.arrDate) {
        content += `<div class="time">预计到达: ${schedule.arrDate}</div>`
      }

      // 显示出发时间
      if (schedule.depDate) {
        content += `<span class="time">预计出发: ${schedule.depDate}</span>`
      }

      // 显示处理时间
      if (schedule.operateTimeMinutes) {
        content += `<div class="duration">处理时间: ${schedule.operateTimeMinutes}分钟</div>`
      }

      content += `</div></div><br>`
    })

    // 显示最终派送信息
    if (vo.acquireSiteUnloadDate) {
      content += `<div class="timeline-item">`
      content += `<div class="timeline-dot end"></div>`
      content += `<div class="timeline-content">`
      content += `<div class="site-name">目的站点</div>`
      content += `<div class="time">预计到达: ${vo.acquireSiteUnloadDate}</div>`
      content += `</div></div>`
    }

    content += '</div></div>'
    return content
  }

  return ''
}

// 渲染警告信息
const renderWarnInfo = (row) => {
  if (!row.success || !row.price_data || !row.price_data.warn_info) return ''

  const warnInfo = row.price_data.warn_info

  if (typeof warnInfo === 'string') {
    return warnInfo
  } else if (Array.isArray(warnInfo) && warnInfo.length > 0) {
    // 如果数组第一个元素是字符串，则直接 join；否则按对象格式渲染
    if (typeof warnInfo[0] === 'string') {
      return warnInfo.join('<br>')
    } else {
      return warnInfo.map(item => {
        if (typeof item === 'object' && item !== null) {
          // 顺心捷达格式
          if (item.descriptionContent) {
            return item.descriptionContent
          } else {
            return Object.entries(item).map(([k, v]) => `${k}: ${v}`).join('<br>')
          }
        }
        return String(item)
      }).join('<br><br>')
    }
  } else if (typeof warnInfo === 'object') {
    // 通用对象格式
    return Object.entries(warnInfo).map(([key, value]) => {
      if (typeof value === 'string') return `${key}: ${value}`
      if (Array.isArray(value)) return `${key}: ${value.join(', ')}`
      if (typeof value === 'object') return `${key}: ${JSON.stringify(value)}`
      return `${key}: ${value}`
    }).join('<br>')
  }

  return ''
}

// 渲染其他信息
const renderOtherInfo = (row) => {
  if (!row.success || !row.price_data || !row.price_data.other_info) return ''

  const otherInfo = row.price_data.other_info

  if (typeof otherInfo === 'string') {
    return otherInfo
  } else if (Array.isArray(otherInfo)) {
    // 顺心捷达和其他格式的数组处理
    return otherInfo.join('<br>')
  } else if (typeof otherInfo === 'object') {
    if (otherInfo.hasOwnProperty('remark')) {
      // 韵达格式
      return otherInfo.remark
    } else {
      // 通用对象格式
      return Object.entries(otherInfo).map(([key, value]) => {
        if (typeof value === 'string') return `${key}: ${value}`
        if (typeof value === 'object') return `${key}: ${JSON.stringify(value)}`
        return `${key}: ${value}`
      }).join('<br>')
    }
  }

  return ''
}

// 处理修改密码
const handleChangePassword = () => {
  ElMessage.info('修改密码功能开发中')
}




</script>

<style scoped>
.cost-query-container {
  width: 100vw;
  background-color: #f5f7fa;
  padding: 20px;
  box-sizing: border-box;
  overflow-y: auto;
  max-height: 100vh;
}

.cost-query-content {
  width: 100%;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  padding: 20px;

  box-sizing: border-box;
}

.cost-query-content h1 {
  font-size: 24px;
  color: #303133;
  margin-bottom: 20px;
  text-align: center;
}

.cost-query-form {
  width: 100%;
}

.natural-language-row {
  margin-bottom: 10px;
}

.natural-language-input {
  display: flex;
  gap: 12px;
  align-items: stretch;
  width: 100%;
}

.natural-language-input .el-textarea {
  flex: 1;
}

.natural-language-input .el-textarea .el-textarea__inner {
  min-height: 100% !important;
}

.parse-btn {
  flex-shrink: 0;
  align-self: stretch;
  margin-top: 0;
  height: auto !important;
}

.text-danger {
  color: #f56c6c;
}

.result-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.result-header h3 {
  margin: 0;
  font-size: 18px;
  color: #303133;
}

.query-id {
  font-size: 14px;
  color: #606266;
}

.w-full {
  width: 100%;
  display: block;
  text-align: center;
}

/* 图标样式 */
.el-icon-warning-outline,
.el-icon-time,
.el-icon-info {
  cursor: pointer;
}

.mb-4 {
  margin-bottom: 20px;
}

/* 表格样式 */
.el-table {
  font-size: 14px;
}

/* 缩略地址样式 */
.ellipsis-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 150px;
  display: inline-block;
  cursor: pointer;
}

.result-scroll-container {
  margin-top: 20px;
  overflow-y: auto;
  max-height: none;
}

.company-results {
  padding-right: 10px;
}

/* 自定义滚动条样式 */
.result-scroll-container::-webkit-scrollbar {
  width: 6px;
}

.result-scroll-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

/* 时间线样式 */
.timeline {
  position: relative;
  padding-left: 20px;
}

.timeline::before {
  content: '';
  position: absolute;
  left: 6px;
  top: 20px;
  bottom: 20px;
  width: 2px;
  background: #e0e0e0;
}

.timeline-item {
  position: relative;
  margin-bottom: 15px;
}

.timeline-dot {
  position: absolute;
  left: -18px;
  top: 5px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #409eff;
  border: 2px solid #fff;
  box-shadow: 0 0 0 2px #409eff;
}

.timeline-dot.start {
  background: #67c23a;
  box-shadow: 0 0 0 2px #67c23a;
}

.timeline-dot.end {
  background: #f56c6c;
  box-shadow: 0 0 0 2px #f56c6c;
}

.timeline-content {
  background: #f9f9f9;
  padding: 10px;
  border-radius: 6px;
  border-left: 3px solid #409eff;
}

.timeline-item:first-child .timeline-content {
  border-left-color: #67c23a;
}

.timeline-item:last-child .timeline-content {
  border-left-color: #f56c6c;
}

.total-time {
  font-weight: bold;
  color: #303133;
  margin-bottom: 10px;
}

.route-desc {
  color: #606266;
  font-size: 12px;
  margin-bottom: 8px;
  word-break: break-all;
}

.site-name {
  font-weight: bold;
  color: #303133;
  margin-bottom: 5px;
}

.site-type {
  color: #606266;
  font-size: 12px;
  margin-bottom: 5px;
}

.status {
  color: #67c23a;
  font-weight: bold;
  margin-bottom: 5px;
}

.time {
  color: #606266;
  font-size: 13px;
  margin-bottom: 3px;
}

.duration {
  color: #f56c6c;
  font-size: 13px;
}

.declared-value-wrap {
  position: relative;
  width: 100%;
}

.quick-declare {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  gap: 6px;
  z-index: 2;
}

.quick-declare-tag {
  padding: 0 8px;
  font-size: 12px;
  line-height: 20px;
  border: 1px solid #409eff;
  color: #409eff;
  border-radius: 4px;
  cursor: pointer;
  background: #ecf5ff;
  user-select: none;
}

.quick-declare-tag:hover {
  background: #409eff;
  color: #fff;
}

.destination {
  color: #409eff;
  font-size: 13px;
  margin-top: 3px;
}

.result-scroll-container::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.result-scroll-container::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 韵重货报价样式 */
.yunda-heavy-price {
  font-size: 13px;
  color: #67c23a;
  margin-top: 3px;
}

/* 加价方案选择栏 */
.strategy-select-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}

.strategy-label {
  font-size: 14px;
  color: #606266;
  flex-shrink: 0;
}

.strategy-tip {
  font-size: 12px;
  color: #909399;
}
</style>